import ContentLoader from "react-content-loader";
import { useMediaQuery } from "react-responsive";
import { Color } from "../../enums/Color";
import { merge } from "react-merge";

const loaderStyle = {
    mobile: {
        container: {
            width: "90.33vw",
            height: "111.59vw"
        }
    },
    desktop: {
        container: {
            width: "43vw",
            height: "60.00vw"
        }
    }
};

export const JobEditPageLoader: React.FC = () => {
    const isMobile = useMediaQuery ({ query: "(max-width: 786px)"});
    var styles = loaderStyle.mobile;

    if(!isMobile) {
        let extendedStyle = merge(loaderStyle.mobile, loaderStyle.desktop);
        styles = extendedStyle;
    }

    return (
       <div style={styles.container}>
            <ContentLoader
                speed={1}
                backgroundColor={Color.LoaderBackground}
                foregroundColor={Color.LoaderForeground}
                width= {styles.container.width}
                height= {styles.container.height}
            >
                {isMobile ? <>
                    <rect x="10%" y="10%" rx="0" ry="0" width="100%" height="6.90%" />
                    <rect x="10%" y="24.42%" rx="0" ry="0" width="100%" height="10.98%" />
                    <rect x="10%" y="38.42%" rx="0" ry="0" width="100%" height="10.98%" />
                    <rect x="10%" y="52.42%" rx="0" ry="0" width="100%" height="10.98%" />
                    <rect x="10%" y="62.42%" rx="0" ry="0" width="100%" height="20.98%" />
                    <rect x="10%" y="88.42%" rx="0" ry="0" width="100%" height="10.98%" />
                </> 
                : <>
                    <rect x="0%" y="8%" rx="0" ry="0" width="70%" height="4.41%" />
                    <rect x="0%" y="20%" rx="0" ry="0" width="100%" height="6.41%" />
                    <rect x="0%" y="30%" rx="0" ry="0" width="100%" height="6.41%" />
                    <rect x="0%" y="40%" rx="0" ry="0" width="48%" height="6.41%" />
                    <rect x="52%" y="40%" rx="0" ry="0" width="48%" height="6.41%" />
                    <rect x="0%" y="50%" rx="0" ry="0" width="100%" height="6.41%" />
                    <rect x="0" y="60%" rx="0" ry="0" width="100%" height="12.00%" /> 
                    <rect x="0" y="74%" rx="0" ry="0" width="100%" height="18.00%" />
                    <rect x="0" y="95%" rx="0" ry="0" width="30%" height="5.00%" />
                    <rect x="70%" y="95%" rx="0" ry="0" width="30%" height="5.00%" />   
                </>} 
            </ContentLoader>
       </div>
    )
}